import { NumberFormatterNoDigits } from 'utils/number';
import Text from '@ingka/text';
import { useNestedTranslation } from 'hooks/useNestedTranslation';
import classes from './Graph.module.scss';

const GraphLegend = ({
    legends
}: {
    legends: { label: string, value?: number, color: string }[]
}) => {
    const t = useNestedTranslation('graph');

    return (
        <div className={classes.legend}>
            {legends.map((legend, index) => (
                <span className={classes['legend-item-container']} key={`${legend.value}-${legend.color}-${legend.label}-${index + 0}`}>
                    <div className={classes['legend-title-container']}>
                        <div className={`${classes['legend-dot']}`} style={{ backgroundColor: legend.color }} />
                        <Text textStyle="Body.S" className={classes['legend-title']}>{legend.label}</Text>
                    </div>
                    {typeof legend.value === 'number' && (
                    <div className={classes['legend-number-unit-container']}>
                        <Text textStyle="Body.S" className={classes['legend-number']}>{NumberFormatterNoDigits.format(legend.value)}</Text>
                        <Text textStyle="Body.S" className={classes['legend-unit']}>{t('total_hours')}</Text>
                    </div>
                    )}
                </span>
            ))}
        </div>
    );
};

export default GraphLegend;
